export const canEditEquipmentAtTerminal = (
  equipmentLocation: string | undefined,
  activeTerminalName: string | undefined
): boolean =>
  !!equipmentLocation &&
  !!activeTerminalName &&
  equipmentLocation === activeTerminalName;
